import React, { useReducer } from 'react'
import reducer, { setState } from '../utils/CommonReducer'
import { Popup } from '../../design_system/components/Popup/Popup.jsx'
import { Button } from '../../design_system/components/Button/Button.jsx'
import { Tooltip } from '../../design_system/components/ToolTip/ToolTip.jsx'

const FlagDetails = ({
    post,
    ...props
}) => {
    const [componentState, setComponentState] = useReducer(reducer, {
        popupsList: {}
    })
    const { popupsList } = componentState;

    const detailsPopup = () => {
        return (
            <Popup
                name="Flagged Article"
                maxWidth={480}
                show={true}
                handleOnClosePopup={() => setState(setComponentState)({ popupsList: {} })}
            >
                <div className="newsfeed__flag-section">
                    <div>
                        <span className="body-m-semibold">Flagged by: <span className="body-m-semibold newsfeed__flag-value">{post.flagged_by}</span> on <span className="body-m-semibold newsfeed__flag-value">{post.flagged_at}</span></span>
                    </div>
                    <div className="newsfeed__flag-row">
                        <span className="body-m-semibold">Comments: <span className="body-m-semibold newsfeed__flag-value">{post.flagged_reason}</span></span>
                    </div>
                </div>
            </Popup>
        )
    }

    return (
        <>
            <Tooltip tooltipText="Flagged" placement="bottom-end" showWithoutOverflowing>
                <Button
                    Type="Ghost"
                    LeadingIconProps={{ style: { fill: post.flagged_by ? 'currentColor' : 'none' } }}
                    Size="Small"
                    LeadingIcon="flag"
                    ShowLeadingIcon={true}
                    onClick={() => setState(setComponentState)({ popupsList: { detailsPopup: true } })}
                    customIconClassName="no-margin"
                />
            </Tooltip>
            {popupsList.detailsPopup && detailsPopup()}
        </>
    )
}

export default FlagDetails
